export enum ClaimOptionCode {
  ACCESS_DATA = 'ACCESS_DATA',
  EXPORT_DATA = 'EXPORT_DATA',
  RESTRICT_PROCESSING = 'RESTRICT_PROCESSING',
  CORRECT_DATA = 'CORRECT_DATA',
  OPPOSE_ADMINISTRATOR = 'OPPOSE_ADMINISTRATOR',
  FORGET_CLIENT = 'FORGET_CLIENT',
  WITHDRAW_AGREEMENT = 'WITHDRAW_AGREEMENT',
  RESTRICT_PROFILING = 'RESTRICT_PROFILING',
}

export interface ClaimOption {
  id: number;
  code: ClaimOptionCode;
  name: string;
  description: string;
}

export interface ClaimUser {
  id: number;
  civilId: string;
  fullName: string;
}

export interface ClaimOperator {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
}

export interface ClaimBase {
  completed?: boolean;
  id?: number;
  notes?: string;
  subject?: string;
  user?: ClaimUser;
  claimOption?: ClaimOption | null;
  accepted?: boolean;
  completedBy?: ClaimOperator | null;
  acceptedBy?: ClaimOperator | null;
}

export interface Claim extends ClaimBase {
  time?: string;
  completedAt?: string | null;
  acceptedAt?: string | null;
}

export interface DeserializedClaim extends ClaimBase {
  time?: Date;
  completedAt?: Date;
  acceptedAt?: Date;
}

export interface EditClaim {
  completed?: boolean;
  notes?: string;
}
